import { HotelResult, HotelSearchResults } from '@/api.ts'
import React from 'react'
import HotelCard from './HotelCard'

interface HotelCardListProps {
  hotelResults: HotelSearchResults
}

const HotelCardList: React.FC<HotelCardListProps> = ({ hotelResults }) => {
  // Check if hotelResults has hotels array
  if (!hotelResults?.hotels || hotelResults.hotels.length === 0) {
    return null
  }

  return (
    <div
      style={{
        width: '100%',
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      {hotelResults.hotels.map((hotel: HotelResult, index: number) => (
        <HotelCard key={hotel.id || index} hotel={hotel} />
      ))}
    </div>
  )
}

export default HotelCardList
